import { createAsyncThunk } from "@reduxjs/toolkit";
import { encryptPayload } from "./encrypt";
import { BASE_URL } from "constants/routes";

const CreateEloquentRequestNC = async (url, params) => {
  const req_body = { body: params };
  const encryptedBodyRes = await encryptPayload("", req_body, true, true);

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };

  try {
    const result = await encryptPayload(url, options, false, true);
    return result;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

/**
 * Create an asynchronous action using createAsyncThunk.
 * @param {string} actionName - The name for this asynchronous action.
 * @param {string} url - The URL or API endpoint for the request.
 * @param {object} options - Additional settings for the action.
 * @param {boolean} options.extractData - If true, extracts the 'data' property from the response.
 * @returns {AsyncThunk} - An action creator.
 */

const AssembleAsyncAdventuresNC = (actionName, url, options = {}) => {
  return createAsyncThunk(`paymentRoute/${actionName}`, async (params) => {
    const fullUrl = `${BASE_URL}${url}`;
    try {
      const result = await CreateEloquentRequestNC(fullUrl, params);
      return options.extractData ? result?.data : result;
    } catch (error) {
      console.error(error);
      throw error;
    }
  });
};

export const createRazorpayOrder = AssembleAsyncAdventuresNC(
  "createRazorpayOrder",
  "/payment/createRazorPayOrder"
);

export const createBilldeskOrder = AssembleAsyncAdventuresNC(
"createBilldeskOrder",
"/payment/createBilldeskOrder"
);
export const checkBilldeskPaymentStatus = AssembleAsyncAdventuresNC(
  "retrieveTransactionFromBilldesk",
  "/payment/retrieveTransactionFromBilldesk"
  );

export const verifyRazorpaySignature = AssembleAsyncAdventuresNC(
  "capturePaymentForRazorPay",
  "/payment/capturePaymentForRazorPay"
);

export const createPaymentForEaseBuzz = AssembleAsyncAdventuresNC(
  "createPaymentForEaseBuzz",
  "/payment/createPaymentForEaseBuzz",
  {
    extractData: true,
  }
);

export const encryptAndSendKeys = AssembleAsyncAdventuresNC(
  "encryptPGKeys",
  "/payment/encryptPGKeys"
);

export const decryptKeysFromServer = AssembleAsyncAdventuresNC(
  "decryptKeysFromServer",
  "/payment/decryptKeys"
);

export const getPaymentContentDataTobeDisplayed = AssembleAsyncAdventuresNC(
  "getPaymentContentDataTobeDisplayed",
  "/payment/getPaymentDetailsContent",
  {
    extractData: true,
  }
);

export const createPaymentRequest = AssembleAsyncAdventuresNC(
  "createPaymentRequest",
  "/payment/getPaymentInfoFromMicroservice",
  {
    extractData: true,
  }
);

export const getPaymentDocumentBasedOnPaymentTransactionId =
  AssembleAsyncAdventuresNC(
    "getPaymentDocumentBasedOnPaymentTransactionId",
    "/payment/getPaymentDocumentBasedOnPaymentTransactionId",
    {
      extractData: true,
    }
  );

export const getPaymentAndUserInfo = AssembleAsyncAdventuresNC(
  "getPaymentAndUserInfo",
  "/payment/getPaymentAndUserInfo",
  {
    extractData: true,
  }
);

export const initiatePayment = AssembleAsyncAdventuresNC(
  "initiatePayment",
  "/payment/initiatePayment",
  {
    extractData: true,
  }
);

export const updatePaymentStatusInSubWorkflow = AssembleAsyncAdventuresNC(
  "updatePaymentStatusInSubWorkflow",
  "/payment/updatePaymentStatusInSubWorkflow",
  {
    extractData: true,
  }
);

export const updateOfflineMicroServiceFullPayment = AssembleAsyncAdventuresNC(
  "updateOfflineMicroServiceFullPayment",
  "/payment/updateOfflineMicroServiceFullPayment",
  {
    extractData: true,
  }
);

export const updateOfflineMicroServicePartialPayment =
  AssembleAsyncAdventuresNC(
    "updateOfflineMicroServicePartialPayment",
    "/payment/updateOfflineMicroServicePartialPayment",
    {
      extractData: true,
    }
  );

export const updateFullPaymentDataThroughRequestchange =
  AssembleAsyncAdventuresNC(
    "updateFullPaymentDataThroughRequestchange",
    "/payment/updateFullPaymentDataThroughRequestchange",
    {
      extractData: true,
    }
  );

export const updatePartialPaymentDataThroughRequestchange =
  AssembleAsyncAdventuresNC(
    "updatePartialPaymentDataThroughRequestchange",
    "/payment/updatePartialPaymentDataThroughRequestchange",
    {
      extractData: true,
    }
  );

export const requestChangeForPaymentThroughId = AssembleAsyncAdventuresNC(
  "requestChangeForPaymentThroughId",
  "/payment/requestChangeForPaymentThroughId",
  {
    extractData: true,
  }
);

export const sendPaymentLinkThroughMails = AssembleAsyncAdventuresNC(
  "sendPaymentLinkThroughMails",
  "/payment/sendPaymentLinkThroughMails",
  {
    extractData: true,
  }
);

export const sendPaymentCancelledEvents = AssembleAsyncAdventuresNC(
  "sendPaymentCancelledEvents",
  "/payment/paymentCancelledEvents",
  {
    extractData: true,
  }
);

export const fetchEstampPaymentData = AssembleAsyncAdventuresNC(
  "fetchEstampPaymentData",
  "/payment/fetchEstampPaymentData",
  {
    extractData: true,
  }
);

export const sendEmailsBasedOnRoleOnAction = AssembleAsyncAdventuresNC(
  "sendEmailsBasedOnRoleOnAction",
  "/payment/sendEmailsBasedOnRoleAction",
  {
    extractData: true,
  }
);

export const fetchApproversUserIds = AssembleAsyncAdventuresNC(
  "fetchApproversUserIds",
  "/dashboard-configuration/fetchApproversUserIds",
  {
    extractData: true,
  }
);

export const shouldShowApprovalButtonBasedOnUserGroup = AssembleAsyncAdventuresNC(
  "shouldShowApprovalButtonBasedOnUserGroup",
  "/dashboard-configuration/shouldShowApprovalButtonBasedOnUserGroup",
  {
    extractData: true,
  }
);



